import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: 'login', loadChildren: () => import('./layouts/login/login.module').then(m=>m.LoginModule) },
  { path: '', pathMatch: 'full', redirectTo: 'app/dashboard' },
  { 
    path: 'app', canActivate: [AuthGuard],
    loadChildren: () => import('./layouts/default/default.module').then(m=>m.DefaultModule)
  },
  { path: '404', redirectTo: 'app/dashboard' },
  { path: '**', redirectTo: 'app/dashboard' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
